<script setup>
import { useGesture } from '@/composables/calendar/useGesture';
import { useDeviceDetect } from '@/composables/useDeviceDetect';
import '@/assets/nangman_style/popup/saju-reading_mobile.scss';
import IconArrow09 from '@/components/svg/IconArrow09.vue';
import ComLoginMessage from '@/components/mobile/_com_login_message.vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
// import { getSajuAnalysisData } from '@/api/personality'
import { fetchBaseServiceAPI } from '@/api/baseServiceApi';
import fiveMixin from '@/composables/fiveMixin';
import {
  splitFirstSentence,
  splitBySentence,
  splitArrayByPipe,
  formatDoubleHash,
} from '@/composables/splitSentence';
import { useAnalysisStore } from '@/store/modules/analysis';
import ConfirmComponent from '@/components/common/Confirm.vue';
const analysisStore = useAnalysisStore();

definePage({ meta: { layout: 'empty' } });
const emit = defineEmits(['close', 'handleRegSave', 'redirectToLogin']);
const props = defineProps({
  prSajuData: Object,
  prBirthData: Object,
  langMode: String,
  // five: Object,
  transData: Object,
  rsGuestUserId: Number,
});

const handleRegSave = (callback) => {
  emit('handleRegSave', callback);
};

const redirectToLogin = () => {
  emit('redirectToLogin', { redirectOption: 'reading' });
};

/** 디바이스 감지 */
const { isMobile } = useDeviceDetect();
const { ...five } = fiveMixin();
const route = useRoute();
const router = useRouter();
const currentPage = ref(0);
const infoPage = ref(false);
const dialogConfirm = ref(null);
const dialogTitle = ref('');
const dialogTitle2 = ref('');
const dialogText = ref('');
const dialogNextUrl = ref('');
const isDataLoading = ref(false);

/** 사주풀이 데이터 */
const sData = ref({});

let ilgan = null;
let fiveData = null;
let gg = null;
let twelve = null;
let sal = null;

/** 사주풀이 요청 데이터 */
const params = computed(() => {
  if ((!props.prSajuData || Object.keys(props.prSajuData).length === 0) && !sajuReadingData.value) {
    return null;
  }

  const sajuData = sajuReadingData.value || props.prSajuData;
  const birthData = sajuReadingData.value?.birthganji || props.prSajuData.birthganji;

  // baseCode 생성하기
  const codeValues = [
    birthData.sky.hour?.value !== '-' ? birthData.sky.hour.value : '-',
    birthData.earth.hour?.value !== '-' ? birthData.earth.hour.value : '-',
    birthData.sky.day.value,
    birthData.earth.day.value,
    birthData.sky.month.value,
    birthData.earth.month.value,
    birthData.sky.year.value,
    birthData.earth.year.value,
  ];
  const baseCode = codeValues.join('');

  const paramsObject = {
    baseCode: baseCode,
    lang: 'KOR',
    birth: sajuData.solar ?? null,
    userName: sajuData.inputdata.name ?? '', // TODO: '' 대신 analysisStore 활용
    bln: sajuData.transdata.lucknum ?? null,
    gender: Number(sajuData.inputdata.gender) ?? null,
    unknownTime: sajuData.inputdata.unknown_time ?? null,
    analysisTypeId: 8,
  };

  return paramsObject;
});

/** 일간 구하기 */
const ilganChar = computed(() => {
  if (ilganInfo.value !== '') return ilganInfo.value.char;
  else return props.prSajuData?.birthganji?.sky?.day?.value;
});
const ilganChnChar = computed(() => {
  return five.getHanjaTxt(ilganChar.value, 'sky');
});

const guestUserId = ref(props.rsGuestUserId || null);
const ilganInfo = ref('');
const sajuReadingData = ref(null);

const store = useStore();
const userId = ref(null);
userId.value = store.getters['user/id'];
const accessToken = ref(!!userId.value || !!sessionStorage.getItem('X-Token'));

/** 분석권 정보 요청중 */
const loadingTicketInfo = ref(false);

onMounted(async () => {
  readyToShow.value = true;

  if (props.rsGuestUserId) {
    guestUserId.value = props.rsGuestUserId;
    loadingTicketInfo.value = true;
    try {
      await analysisStore.getAnalysisLog(props.rsGuestUserId, 4); // 용신분석 typeId: 4
    } catch (e) {
    } finally {
      loadingTicketInfo.value = false;
    }
  }
});

/** 사주풀이 데이터 요청 */
const fetchSajuDescData = async () => {
  if (!params.value) return;

  try {
    const result = await fetchBaseServiceAPI(params.value);
    sData.value = result.data;

    ilgan = createChapterParser(sData, '일간특성');
    fiveData = createChapterParser(sData, '오행분포', { usePipe: true });
    gg = createChapterParser(sData, '격국특성');
    twelve = createChapterParser(sData, '십이운성특성');
    sal = createChapterParser(sData, '십이신살특성');
  } catch (error) {
    console.error('fetchSajuDescData 실패', error);
  } finally {
    isDataLoading.value = false;
  }
};

watch(
  () => params.value,
  async (newParams) => {
    isDataLoading.value = true;
    if (newParams) await fetchSajuDescData();
  },
  { immediate: true },
);

/** 용신분석권 활성화 여부 */
const yongsinPermission = computed(() => {
  const logList =
    analysisStore.analysisLogByType[4] ||
    analysisStore.analysisLogData?.filter((item) => item.analysisTypeId === 4) ||
    [];
  return logList.length > 0;
});
watch(guestUserId, async (newId) => {
  if (newId) {
    loadingTicketInfo.value = true;
    try {
      await analysisStore.getAnalysisLog(newId, 4); // 용신분석 typeId: 4
    } catch (e) {
    } finally {
      loadingTicketInfo.value = false;
    }
  }
});

/** 데이터 할당 */
function createChapterParser(dataRef, chapterKey, options = {}) {
  const data = computed(() => dataRef.value[chapterKey]);

  const split = computed(() => splitFirstSentence(data.value?.기본특성));
  const keySentence = computed(() => split.value.first);
  const description = computed(() => split.value.restSentences);
  const detail = computed(() => splitBySentence(data.value?.상세특성));
  const strength = computed(() => splitBySentence(data.value?.강점설명));

  // 오행 기본특성 분리
  const pipeSplit = options.usePipe
    ? computed(() => splitArrayByPipe(split.value.restSentences))
    : null;
  const before = options.usePipe ? computed(() => pipeSplit.value.before) : null;
  const after = options.usePipe ? computed(() => pipeSplit.value.after) : null;

  return {
    data,
    split,
    keySentence,
    description,
    detail,
    strength,
    before,
    after,
  };
}

/** 오행 첫 문장(이름 분리ver) */
const fiveKeySentenceHtml = computed(() => {
  return formatDoubleHash(fiveData.keySentence.value);
});

const readyToShow = ref(false);

const clickPrevPage = () => {
  if (currentPage.value < 1) return;
  else currentPage.value -= 1;
};

const clickNextPage = () => {
  if (currentPage.value > 2) return;
  else currentPage.value += 1;
};

const onSwipeLeft = () => {
  if (currentPage.value === 0 || currentPage.value > 2) return;
  else currentPage.value += 1;
};

const onSwipeRight = () => {
  if (currentPage.value < 1) return;
  else currentPage.value -= 1;
};

const openInfoPage = () => {
  if (loadingTicketInfo.value) return;

  if (route.params.id && yongsinPermission.value) {
    analysisStore.selectedMenu = '/overviewYongsin';
    router.push(`/analysis/${route.params.id}`);
  } else {
    currentPage.value = 1;
    infoPage.value = false;
  }
};

/** 통합 제스처 핸들러 */
const { handleStart, handleMove, handleEnd } = useGesture({
  onSwipeLeft: onSwipeLeft, // 왼쪽 스와이프 → 다음 페이지 이동
  onSwipeRight: onSwipeRight, // 오른쪽 스와이프 → 이전 페이지 이동
  SWIPE_THRESHOLD: 150,
});

const clickStart = () => {
  infoPage.value = false;
  currentPage.value = 1;
};

/** 팝업 닫기 */
const close = () => {
  emit('close');

  setTimeout(() => {
    readyToShow.value = false;
  }, 500);
};

const resetPopup = () => {
  currentPage.value = 0;
  infoPage.value = false;
};

const login = () => {
  redirectToLogin();
};

const routeTab = () => {
  if (accessToken.value) {
    analysisStore.selectedMenu = '/overviewYongsin';
    if (route.params.id) {
      router.push(`/analysis/${route.params.id}`);
    } else {
      handleRegSave(() => router.push('/saju-service'));
    }
  } else {
    showDialogConfirm('로그인 후 이용해 주세요.', '', '로그인', () => {
      redirectToLogin();
    });
  }
};
const goToPurchasePage = () => {
  router.push('/purchase/tickets');
};

const showDialogConfirm = (title, title2 = '', text = '', onConfirm = () => {}) => {
  dialogTitle.value = title;
  dialogTitle2.value = title2;
  dialogText.value = text;
  dialogNextUrl.value = onConfirm; // 함수로 전달

  dialogConfirm.value.openConfirmDialog();
};

const message1 = ref('로그인 🔒 하면<br />사주팔자 해석 🔎 을 무료로 볼 수 있어요!');
const message2 = ref('당신의 사주엔 아직 펼쳐지지 않은<br>더 많은 이야기들이 있습니다 😊');
const message3 = ref('지금 보신 해석은,<br>사주팔자 속 핵심 기운만 간단히 요약한<br>첫인상이에요.');
const message4 = ref('"왜 나는 이런 기운을 가졌을까?"<br>"앞으로의 흐름은 어떻게 흘러갈까?"');
</script>

<template>
  <div
    class="pop-saju-reading-container"
    :class="{ mobile: isMobile }"
    @mousedown="handleStart"
    @mousemove="handleMove"
    @mouseup="handleEnd"
    @touchstart="handleStart"
    @touchmove="handleMove"
    @touchend="handleEnd"
  >
    <div
      v-if="currentPage === 0 && readyToShow"
      class="pop-saju-reading-inner intro st-analysis-intro-wrap"
    >
      <div class="pop-header__large intro">
        <button @click="close"><i class="pop-header__close"></i></button>
        <div class="ys-analysis-main-title">
          <div class="icon">🔎️️</div>
          <div class="text-box">
            <div class="txt1">‘용신(用神)’이란 도대체 무엇일까!</div>
            <div class="txt2">나를 조화롭게 만들어주는 중심축</div>
            <div class="txt3-box">
              <div class="txt3">전문가를 위한 용신 분석 서비스</div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="pop-body intro"
        :class="isMobile ? 'pd-16 st-analysis-intro-pd' : 'pd-40'"
      >
        <div class="pop-body__inner">
          <div class="ys-analysis-sub-box">
            <div class="tit-box">🗝 내 인생의 흐름을 바꿀 열쇠가 있을까?</div>
            <div class="desc-wrap">
              <div class="desc-box">
                사주를 처음 접하는 사람들이 가장 많이 던지는 질문입니다. 살다 보면 어떤 시기에는
                모든 일이 순조롭다가도,<br />어떤 시기에는 작은 일조차 어긋나기 쉽다는 걸
                경험합니다.
              </div>
              <div class="desc-box">
                그럴 때 자연스럽게 묻게 됩니다. “어떤 기운을 채워야 운이 트일까?”<br />
                “내 사주에서 무엇이 부족한 걸까!”
              </div>
              <div class="desc-box">
                이 질문의 끝에 자주 등장하는 단어가 바로 <b>“용신”</b>입니다.
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isMobile" class="ys-analysis-pop-btm-box">
          낭만만세력의 <b>“용신분석”</b>은 사주를 깊이 공부하거나<br />
          실제 <b>상담과 연구를 이어가는 분들</b>을 위해 준비된 서비스입니다<br />
          <br />
          다각도의 구조 분석을 바탕으로 신뢰할 수 있는 <b>보조 자료를 제공해드리고자</b>합니다.
        </div>
        <div v-else class="ys-analysis-pop-btm-box">
          낭만만세력의 <b>“용신분석”</b>은 사주를 깊이 공부하거나<br />
          실제 <b>상담과 연구를 이어가는 분들</b>을 위해<br />
          준비된 서비스입니다<br />
          <br />
          다각도의 구조 분석을 바탕으로 신뢰할 수 있는<br />
          <b>보조 자료를 제공해드리고자</b>합니다.
        </div>
        <button
          :style="{ marginBottom: `calc(16px + var(--safe-area-bottom, 0px))` }"
          class="start-button"
          @click="openInfoPage"
        >
          바로 시작하기
        </button>
      </div>
    </div>

    <div v-if="currentPage !== 0 && readyToShow" class="pop-saju-reading-inner gray100">
      <div class="pop-header__small">
        <button @click="close"><i class="pop-header__close"></i></button>
        <div class="pop-header__content">
          <div class="pop-header__title_2 st-analysis-header" v-if="currentPage === 1">
            <i class="icon-search">🔎️️️</i>
            <span class="st-analysis-header-txt"
              ><em class="txt-bold">전문가를 위한 용신 분석 서비스</em></span
            >
          </div>
          <div class="pop-header__title_2 st-analysis-header" v-if="currentPage === 2">
            <i class="icon-search">🔎️️️</i>
            <span class="st-analysis-header-txt"
              ><em class="txt-bold">전문가를 위한 용신 분석 서비스</em></span
            >
          </div>
          <div class="pop-header__title_2 st-analysis-header" v-if="currentPage === 3">
            <i class="icon-search">🔎️️️</i>
            <span class="st-analysis-header-txt">
              <em class="txt-bold">이렇게 활용해 보세요!</em>
            </span>
          </div>
        </div>
      </div>
      <div v-if="currentPage === 1" class="pop-body mobile st-analysis-01 st-analysis-body">
        <div class="yg-guide-box st-guide-01 st-analysis-02">
          <div class="text-box">
            <div class="yg-text-01">
              이 서비스는 <span class="txt-bold">용신 해석의 다양한 기준과 논리</span>를 토대로<br />
              하나의 결과가 아닌 다각적 근거를 한눈에 살펴볼 수 있도록 구성하고 있으며 <br />
              이를 위해 세가지 과정을 거쳐 분석 추론을 제시하고 있습니다.
            </div>
          </div>
          <div class="guide__circle-box">
            <div class="circle-box__overlap-group">
              <div class="personality-circle clear st-ys-guide-01">
                <span class="circle__main-txt">1. 기본 구조 분석</span>
                <span class="circle__sub-txt">
                  사주 원국의 오행 분포,<br />
                  신강·신약, 조후, 격국 등의 <br />기준 요소를 알고리즘으로<br />
                  분석하여 용신을 추론
                </span>
              </div>
              <div class="personality-circle light overlap-circle st-ys-guide-01">
                <span class="circle__main-txt">2. AI 모델 분석</span>
                <span class="circle__sub-txt"
                  >다양한 학습 기반을 가진<br />
                  7가지 AI 모델을 통해,<br />
                  또 다른 시각에서<br />
                  용신을 산출</span
                >
              </div>
            </div>
          </div>
          <div class="guide__arrow-box">
            <IconArrow14 />
          </div>
          <div class="yg-text-02">
            <div class="main-txt">3. 교차 · 종합 분석</div>
            <div class="sub-txt">
              두 결과를 종합하여 상반되거나 특수한 경우를 <b>낭만알고리즘</b>이 다시 검토하여<br />
              그 근거 속에서 가장 타당한 결과를 제시합니다.
            </div>
          </div>
          <div v-if="!isMobile" class="ys-analysis-btm-desc">
            <div class="icon-quote"></div>
            <span>
              <i class="icon-search">🔎️️️</i>
              용신을 찾는다는 건 단순히 “좋은 오행을 골라내는 것”이 아닌<br /><em class="txt-bold"
                >내 삶의 기운이 어떤 흐름으로 이루어져 있는지 이해하는 과정</em
              >입니다.
            </span>
          </div>
          <div v-else class="ys-analysis-btm-desc mobile">
            <div class="icon-quote"></div>
            <span>
              <i class="icon-search">🔎️️️</i>
              용신을 찾는다는 건<br />
              단순히 “좋은 오행을 골라내는 것”이 아닌<br />
              <em class="txt-bold"
                >내 삶의 기운이 어떤 흐름으로 이루어져 있는지<br />
                이해하는 과정</em
              >입니다.
            </span>
          </div>
        </div>
      </div>

      <div v-if="currentPage === 2" class="pop-body mobile st-analysis-body">
        <div class="pop-body__inner page-content-box">
          <div class="st-analysis-02-box">
            <div class="st-analysis-0201">
              <div class="text-box">
                이러한 과정을 통해 제공되는 낭만만세력의 용신분석 데이터는<br />
                <span class="txt-bold-2">오행 분포 · 신강신약 · 조후 · 격국 · 대운 흐름</span>을
                종합하여,<br />
                현재 명식에서 주목할 만한<span class="txt-bold-2">
                  핵심 오행과 그 보조 · 제어 관계</span
                >를 보여줍니다.
              </div>
              <div class="text-box">
                또한 희신 · 기신 · 구신 · 한신의 상호작용과 격국 패턴과 함께,<br />
                향후 대운 흐름속에서 참고할 방향성을 함께 분석하여 제공하고 있습니다.
              </div>
              <div class="st-analysis-0201-gray">
                <div class="text-box">
                  <span class="txt-bold">
                    이 명식은 왜 수(水)를 중심으로 균형을 맞추어야 하는가?”</span
                  ><br />
                  와 같은 질문에 대한 근거를 직관적으로 확인할 수 있습니다.
                </div>
              </div>
            </div>

            <div class="yg-guide-img-0101" :class="{ mobile: isMobile }"></div>
            <div class="st-analysis-0204">
              <div class="text-box">
                이 분석이 연구와 실제 상담을 준비하는 과정에서<br />
                다양한 시각을 얻는 데 작은 도움이 되길 바랍니다.
              </div>
            </div>
            <div v-if="!isMobile" class="ys-analysis-btm-desc">
              <div class="icon-quote"></div>
              <span class="yongsin-bottom">
                <i class="icon-search">🔎️️️</i>
                앞으로도 사주명리의 핵심 가치를 사랑하고 연구 발전에 힘쓰시는 <br />
                모든 분들께 작은 보탬이 될 수 있도록 지속적으로 의견을 듣고 개선하며
                나아가겠습니다.</span
              >
            </div>
            <div v-else class="ys-analysis-btm-desc">
              <div class="icon-quote"></div>
              <span class="yongsin-bottom">
                <i class="icon-search">🔎️️️</i>
                앞으로도 사주명리의 핵심 가치를 사랑하고<br />
                연구 발전에 힘쓰시는 <br />
                모든 분들께 작은 보탬이 될 수 있도록<br />
                지속적으로 의견을 듣고 개선하며<br />
                나아가겠습니다.</span
              >
            </div>
          </div>
        </div>
      </div>
      <div v-if="currentPage === 3" class="pop-body mobile st-analysis-body">
        <div class="pop-body__inner page-content-box">
          <div
            class="title-saju-reading-finish-box"
            :style="{ paddingBottom: isMobile ? '52px' : '0px' }"
          >
            <div class="st-analysis-0301">
              <span class="icon">📖</span>
              <div class="st-analysis-0301-blue">일반 용신 활용</div>
              <div class="st-analysis-0301-txt">
                현재의 나에게 가장 이로운 기운,<br />
                즉 삶의 균형과 활력을 더해주는 ‘용신’을 확인하고<br />
                그 방향을 이해하는 데 도움을 받을 수 있습니다.<br />그리고, 지금 그 여정을 시작해
                보세요.
              </div>
              <div class="st-analysis-0301-blue">전문가 용신 활용</div>
              <div class="st-analysis-0301-txt">
                [용신분석]을 꾸준히 활용하시는 전문가분들께는<br />
                10개~20개 분석권 패키지로<br />
                최대 60% 할인 혜택을 제공해드립니다.<br /><br />
                상담과 연구 준비에 넉넉하게 활용해보세요.
              </div>
            </div>
            <div class="pop-disposition-bottom">
              <button class="bg-button" @click="routeTab">낭만분석 바로 가기</button>
              <button class="bg-button white" @click="goToPurchasePage">
                분석권 할인 구매하러 가기
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="pop-pagination" v-if="!infoPage && currentPage !== 0">
        <div class="pop-pagination__index">0{{ currentPage }} / 03</div>
        <button class="pop-pagination__prev" @click="clickPrevPage">
          <i class="icon-chevron"></i>
        </button>
        <button class="pop-pagination__next" @click="clickNextPage">
          <i class="icon-chevron right"></i>
        </button>
      </div>
    </div>
  </div>
  <ConfirmComponent
    ref="dialogConfirm"
    :title="dialogTitle"
    :title2="dialogTitle2"
    :text="dialogText"
    :nextUrl="dialogNextUrl"
  />
</template>
<style scoped lang="scss">
@import '@/assets/nangman_style/mobile/saju-reading-common.scss';
@import '@/assets/nangman_style/_analysis_main_color.scss';
.ys-analysis-pop-btm-box {
  white-space: pre-line;
  color: var(--Gray-800, #333);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 40px;
  .txt-bold {
    color: var(--Gray-800, #333);
    font-weight: 700;
  }
}

.ys-analysis-sub-box {
  .tit-box {
    color: #4e80d6;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
  .desc-wrap {
    display: flex;
    padding: 0 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    .desc-box {
      color: var(--Gray-700, #575757);
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 160% */
    }
  }
}

.ys-analysis-main-title {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  .txt1,
  .icon {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    color: #4e80d6;
    text-align: center;
    font-family: Pretendard;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 133.333% */
  }
  .txt2 {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    color: var(--Gray-700, #575757);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 160% */
    margin-bottom: 20px;
  }
  .txt3-box {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
  .txt3 {
    display: inline-block;
    margin: auto;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 18px;
    background: #4e80d6;
    color: #fff;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px; /* 112.5% */
  }
}

.ys-analysis-sub-box {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border-radius: 8px;
  background: var(--gray-100-white, #fff);
}

.yg-guide-box.st-analysis-02 {
  max-width: 552px;
  margin: 0 auto;
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  &.bg-blue {
    border-radius: 12px;
    background: $analysis-yongsin-light;
  }
  &.st-guide-01 {
    padding: 20px;
    gap: 40px;
    align-self: stretch;
  }
  .yg-text-01 {
    color: var(--Gray-800, #333);
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 160% */
    .txt-bold {
      color: #4e80d6;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
  }
  .yg-text-02 {
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    align-self: stretch;
    border-radius: 12px;
    border: 1px solid rgba(78, 128, 214, 0.5);
    background: rgba(78, 128, 214, 0.1);
    .main-txt {
      color: $analysis-yongsin;
      text-align: center;
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 150% */
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .sub-txt {
      color: var(--Gray-800, #333);
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 160% */
    }
  }
  .youngsin-guide-title {
    color: $analysis-yongsin;
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px; /* 157.143% */
  }
  .youngsin-guide-txt1 {
    color: var(--Gray-800, #333);
    text-align: center;
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px; /* 160% */
  }
  .youngsin-guide-txt2 {
    color: var(--Gray-800, #333);
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 160% */
  }

  .personality-circle.st-ys-guide-01 {
    width: 180px;
    height: 180px;
    border-radius: 200px;
    border: 1px solid rgba(78, 128, 214, 0.5);
    background: var(--gray-100-white, #fff);
    .circle__main-txt {
      color: $analysis-yongsin;
    }
    .circle__sub-txt {
      color: var(--Gray-700, #575757);
    }
    &.overlap-circle {
      border-radius: 200px;
      border: 1px solid rgba(78, 128, 214, 0.5);
      background: $analysis-yongsin;
      .circle__main-txt,
      .circle__sub-txt {
        color: #fff;
      }
    }
  }
}

.st-analysis-02-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  .st-analysis-0201 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex: 1 0 0;
    width: 100%;
    .text-box {
      width: 100%;
      text-align: center;
      color: #333;
      text-align: center;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 160% */
    }
    .txt-bold-2 {
      color: #4e80d6;
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    }
    .st-analysis-0201-gray {
      margin-top: 16px;
      display: flex;
      padding: 12px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      align-self: stretch;
      border-radius: 12px;
      background: var(--Gray-200, #f8f8f8);
      color: var(--Gray-800, #333);
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      .txt-bold {
        font-weight: 700;
      }
    }
  }
  .st-analysis-0204 {
    color: var(--Gray-800, #333);
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 160% */
  }
}
.yg-guide-img-0101 {
  width: 100%;
  height: 180px;
  background-image: url('@manseImages/yg-guide-0101.png');
  background-size: 85% auto;
  background-position: center;
  background-repeat: no-repeat;
  &.mobile {
    background-size: 120% auto;
  }
}
.st-analysis-0301 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
  .icon {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px; /* 100% */
  }
  .st-analysis-0301-txt {
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  .st-analysis-0301-blue {
    color: #3b6abb;
    text-align: center;
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 133.333% */
  }
}
.pop-saju-reading-container .pop-saju-reading-inner .pop-header__title_2.st-analysis-header {
  height: 80px;
}
.st-analysis-header {
  .st-analysis-header-txt {
    width: 100%;
    text-align: left;
    color: var(--Gray-800, #333);
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
    .txt-bold {
      font-weight: 700;
    }
  }
}
.ys-analysis-btm-desc {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
  text-align: center;
  color: var(--Gray-800, #333);
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  .txt-bold {
    font-weight: 700;
  }
}
.title-saju-reading-finish-box {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  gap: 40px;
  .txt-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .txt {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    color: var(--Gray-700, #575757);
    text-align: center;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 160% */
    .icon {
      color: var(--Gray-800, #333);
      font-family: Pretendard;
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 28px; /* 100% */
    }
  }
}
.pop-body__title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px !important;
  .icon {
    font-size: 28px !important;
    font-weight: 700;
    display: flex;
    width: 44px !important;
    height: 44px;
    align-items: center;
  }
  .title {
    display: flex;
  }
}
.pop-body__desc-wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  .tit {
    color: var(--Gray-700, #575757);
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 160% */
  }
  .txt_wrap {
    width: 100%;
    .txt {
      color: var(--Gray-700, #575757);
      font-family: Pretendard;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 160% */
    }
  }
}
.bg-button {
  display: flex;
  width: 100%;
  height: 48px;
  min-width: 80px;
  padding: 14px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 6px;
  background: var(--orange-300-main, #eb4c10);
  color: var(--gray-100-white, #fff);
  text-align: center;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  &.white {
    border: 1px solid var(--orange-300-main, #eb4c10);
    background: var(--gray-100-white, #fff);
    color: var(--orange-300-main, #eb4c10);
  }
}

// .saju-reading-dialog .pop-saju-reading-container .pop-saju-reading-inner {
//   position: relative;
// }
// .saju-reading-dialog .pop-saju-reading-container .pop-saju-reading-inner .pop-body {
//   .pop-body__content {
//     gap: 0;
//     border-radius: 12px;
//   }
//   .pop-body__desc {
//     border-radius: 0;
//   }
// }
.default-inner-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.saju-pop__outro {
  color: var(--Gray-700, #575757);
  text-align: center;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  .colored-txt {
    color: var(--orange-300-main, #eb4c10);
  }
}

@media (max-width: 768px) {
  // .ys-analysis-sub-box .desc-wrap .desc-box {
  //   br {
  //     display: none;
  //   }
  // }
  // .ys-analysis-pop-btm-box {
  //   br {
  //     display: none;
  //   }
  // }
  // .yg-guide-box.st-analysis-02 .yg-text-01 {
  //   br {
  //     display: none;
  //   }
  // }

  // .st-analysis-02-box {
  //   .st-analysis-0201 {
  //     br {
  //       display: none;
  //     }
  //   }
  // }
  .guide__circle-box .circle-box__overlap-group {
    flex-direction: column;
    gap: 0;
  }
  .yg-guide-box.st-analysis-02 .personality-circle.st-ys-guide-01 {
    width: 200px !important;
    height: 200px !important;
    margin: -12px 0 0 0 !important;
  }
  .pop-body.st-analysis-body {
    height: calc(100vh - 140px);
  }
  .pop-saju-reading-container
    .pop-saju-reading-inner.st-analysis-intro-wrap
    .pop-body.intro
    .pop-body__inner {
    height: auto;
    overflow: visible;
  }
  .pop-saju-reading-container .pop-saju-reading-inner.st-analysis-intro-wrap {
    overflow: hidden;
    height: 100dvh;
    max-height: 100dvh;
    display: flex;
    flex-direction: column;
  }
  .pop-saju-reading-container .pop-saju-reading-inner.st-analysis-intro-wrap .pop-body.intro {
    flex: 1;
    overflow-y: auto;
  }
  .pop-saju-reading-container .pop-saju-reading-inner.st-analysis-intro-wrap .start-button {
    flex-shrink: 0;
  }
  .pop-saju-reading-container
    .pop-saju-reading-inner.st-analysis-intro-wrap
    .pop-body.intro.st-analysis-intro-pd {
    .ys-analysis-sub-box {
      margin-bottom: 24px;
    }
  }
}

.icon-quote {
  width: 28px;
  height: 22px;
  background: url('/src/assets/images_manse/icon_quotes.svg') center center no-repeat;
  background-size: contain;
}
.pop-disposition-bottom {
  width: 343px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.yongsin-bottom {
  font-size: 15px;
}
</style>
